export default "__VITE_ASSET__S1SXhwz2__"